import { TCutPanelInspectionDB } from '@monorepo/types';
import { CutPanelInspectionDBActionTypes, TCutPanelInspectionActions } from './cut-panel-inspection.actions';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';

export function getCutPanelInspectionInitialState(nextCacheResetTimestamp: number): TCutPanelInspectionDB {
  return {
    nextCacheResetTimestamp,
    recentRecuts: {
      default: [],
    },
    counts: {},
    selectedMasterCutDisplayTag: null,
  };
}

export function CutPanelInspectionStateReducer(
  state: TCutPanelInspectionDB = getCutPanelInspectionInitialState(INITIAL_CACHE_RESET_TIMESTAMP),
  action: TCutPanelInspectionActions,
): TCutPanelInspectionDB {
  switch (action.type) {
    case CutPanelInspectionDBActionTypes.SetCutPanelInspectionDB:
      return action.db;
    case CutPanelInspectionDBActionTypes.UpdateRecentRecutsList:
      let currentRecentRecutList = [...state.recentRecuts.default];
      const currentRecentRecutListIssueIds = currentRecentRecutList.map((issue) => issue.id);
      action.list.forEach((newIssue) => {
        if (currentRecentRecutListIssueIds.indexOf(newIssue.id) === -1) {
          currentRecentRecutList = produce(currentRecentRecutList, (draft) => {
            draft.push(newIssue);
          });
        }
      });
      return produce(state, (draft) => {
        draft.recentRecuts.default = currentRecentRecutList;
      });
    case CutPanelInspectionDBActionTypes.FetchInspectionCountsSuccess: {
      return produce(state, (draft) => {
        draft.counts.res = action.res;
      });
    }
    case CutPanelInspectionDBActionTypes.SetSelectedMasterCutDisplayTag: {
      return produce(state, (draft) => {
        draft.selectedMasterCutDisplayTag = action.cutDisplayTag;
      });
    }
    default:
      return state;
  }
}
